import { booking_information_token } from "../../../v1_2/Booking/Booking_Information_Token";

export class get_booking {
    public booking_reference: string | null = null;
    public token: booking_information_token = new booking_information_token();
}